const RadioButton = ({ name, value, checked, onChange, label }) => {
    return (
        <label className="flex cursor-pointer items-center space-x-2">
            <input type="radio" name={name} value={value} checked={checked} onChange={onChange} className="peer sr-only" />
            <div className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-white peer-checked:border-white">
                <div className={`h-2.5 w-2.5 rounded-full transition-transform duration-150 ${checked ? 'scale-100 bg-white' : 'scale-0'}`} />
            </div>
            <span>{label}</span>
        </label>
    );
};

export default RadioButton;
